import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromoStructuring = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 7,
			height: 7,
			rx: 1,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 3,
			width: 7,
			height: 7,
			rx: 1,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 14,
			width: 7,
			height: 7,
			rx: 1,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 14,
			width: 7,
			height: 7,
			rx: 1,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		})
	]
});
export default SvgPromoStructuring;
